// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2iIi0","selected":"Chip_selected__78rV3"};